import { createSelector } from 'reselect'

const brand = (state) => state.brand

export const getBrand = createSelector(
  [ brand ],
  (brand) => {
    return Object.assign(
      {},
      brand
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/brand.js